import { card } from "@/components/admin/ui";

const label = (j) =>
  ({ queued: "Queued", starting: "Starting…", uploading: `Uploading ${j.progress}%`, processing: "Uploaded · processing", error: `Error: ${j.error || "upload failed"}` }[j.state] || j.state);

export const UploadPanel = ({ jobs, onClear }) => {
  if (!jobs.length) return null;
  const active = jobs.filter((j) => ["starting", "uploading"].includes(j.state)).length;
  const queued = jobs.filter((j) => j.state === "queued").length;
  return (
    <div className={`${card} p-4 mb-5`} data-testid="upload-panel">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[13px] font-semibold">
          Uploads · {active} active{queued ? ` · ${queued} queued` : ""}
        </p>
        <button type="button" onClick={onClear} className="text-[12px] text-[#6B7280] hover:text-black" data-testid="upload-panel-clear">
          Clear finished
        </button>
      </div>
      <div className="space-y-2.5">
        {jobs.map((j) => (
          <div key={j.id} data-testid="upload-job">
            <div className="flex justify-between text-[12px]">
              <span className="truncate pr-4">{j.file.name}</span>
              <span className={`shrink-0 ${j.state === "error" ? "text-[#B91C1C]" : "text-[#6B7280]"}`} data-testid="upload-job-state">
                {label(j)}
              </span>
            </div>
            <div className="mt-1 h-1.5 rounded bg-[#E5E7EB] overflow-hidden">
              <div className={`h-full transition-all duration-300 ${j.state === "error" ? "bg-[#EF4444]" : j.state === "processing" ? "bg-[#22C55E]" : "bg-[#F8D481]"}`} style={{ width: `${j.state === "queued" ? 0 : j.progress}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
